import en from './Resources.en.json';
import kk from './Resources.kk.json';
import zh from './Resources.zh.json';
import ru from './Resources.ru.json';
import { Resource } from 'i18next';

export const Resources: Resource = {
  en: { translation: { ...en } },
  kk: {
    translation: { ...en, ...kk },
  },
  zh: {
    translation: { ...en, ...zh },
  },
  ru: {
    translation: { ...en, ...ru },
  },
};
